export default class CreateNovedad {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, novedad) {
    const payload = {
      fk_idTipoNovedad: novedad.fk_idCatTipoNovedad,
      detalleNovedad: novedad.descripcion,
      fecha: novedad.fecha,
    }
    return await this.#repository.create(idPersonal, payload)
  }
}
